export default __webpack_public_path__ + "static/media/Unirab-20-eng.e07d2a9e.jpg";